import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd';
import { _HttpClient } from '@delon/theme';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MessageService } from 'icc-common-lib';
import { DialogService } from 'icc-common-lib';
import { URLS } from '../../../shared/constant/interface';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.less'],
})
export class TiktokConstraintKeywordEditComponent implements OnInit {

  static NAME = 'icc-msg';

  constructor(private messageService: MessageService, private modal: NzModalRef, public http: _HttpClient, private fb: FormBuilder, private dialogService: DialogService) {}
  bizEnums = [];
  bizEnumsBack = [];
  bizList: any[];
  channelEnums = [];
  channelEnumsBack = [];
  channelList: any[];
  userEnums = [];
  userEnumsBack = [];
  userList: any[];
  record: any;
  subject = '敏感字管控';
  showFlag = true;
  msgType = -1;
  companyWechat: any;
  all: any;
  logicKeywordCont = true;
  keywordRepe = true;

  form: FormGroup;

  controlType = 3;
  accountDisabled = false;
  keywordType = 1;
  msgTypeDisabled = true;
  allDisabled = false;
  ngOnInit() {
    const urlSel = URLS.blacklistAllUsers.url;
    this.msgType = this.messageService.getMsgTypeByName('tiktok', true);
    this.form = this.fb.group({
      id: new FormControl(null),
      keywordType: new FormControl('1', [Validators.required]),
      keyword: new FormControl(null, [Validators.required, Validators.maxLength(100)]),
      targetId: new FormControl(null, [Validators.required]),
      controlType: new FormControl('3', [Validators.required]),
      controlStrategy: new FormControl('1', [Validators.required]),
      logicKeyword: new FormControl('-1', [Validators.required]),
      keywordRepe: new FormControl('-1', [Validators.required]),
    });
    this.http.post(urlSel).subscribe(res => {
      this.userList = res.data;
      if (this.userList.length > 0) {
        this.userList.forEach((user, index: number, array) => {
          this.userEnums.push({ label: user.account, value: user.id });
          this.userEnumsBack.push({ label: user.account, value: user.id });
        });
      }
      if (this.record.id > 0) {
        // 目标账户
        this.form.get('controlType').setValue(this.record.controlType + '');
        this.form.get('keyword').setValue(this.record.keyword);
        this.form.get('keywordType').setValue(this.record.keywordType + '');
        this.form.get('controlStrategy').setValue(this.record.controlStrategy + '');
        this.form.get('id').setValue(this.record.id);
        this.form.get('targetId').setValue(this.record.targetId);
        this.controlType = this.record.controlType;
        this.checkExist(this.record.keyword);
      }
    });
    this.http.post(URLS.keywordAllBizs.url + this.msgType).subscribe(res => {
      this.bizList = res.data;
      if (this.bizList.length > 0) {
        this.bizList.forEach((biz, index: number, array) => {
          this.bizEnums.push({ label: biz.name, value: biz.id });
          this.bizEnumsBack.push({ label: biz.name, value: biz.id });
        });
      }
    });
    this.http.post(URLS.keywordAllChannels.url + this.msgType).subscribe(res => {
      this.channelList = res.data;
      if (this.channelList.length > 0) {
        this.channelList.forEach((channel, index: number, array) => {
          this.channelEnums.push({ label: channel.name, value: channel.id });
          this.channelEnumsBack.push({ label: channel.name, value: channel.id });
        });
      }
    });
  }

  controlTypeChange(value: any) {
    if (value == 1) {
      this.form.get('targetId').setValue(0);
      this.controlType = 1;
    } else {
      this.form.get('targetId').setValue(null);
      this.controlType = 2;
    }
    if (this.record.controlType == 2 && this.controlType == 2) {
      this.accountDisabled = true;
      this.form.get('targetId').setValue(this.record.targetId);
    }
  }

  checkAccount() {
    if (this.form.get('keyword').value) {
      this.checkExist(this.form.get('keyword').value);
    }
  }
  keywordTypeChange(value: any) {
    if (value == 1) {
      this.keywordType = 1;
      this.logicKeywordCont = true;
      this.form.get('logicKeyword').setValue('-1');
      this.checkExist(this.form.get('keyword').value);
    } else {
      this.keywordType = 2;
      this.isValidLogicKeyword(this.form.get('keyword').value);
    }
  }

  isValidLogicKeyword(s) {
    let offset = 1;
    let orflag = 0;
    let andflag = 0;
    if (this.keywordType !== 1) {
      if (s.indexOf('()') >= 0 || s.lastIndexOf('!') === s.length - 1 || s.indexOf('|') === 0 || s.indexOf('&') === 0 || s.indexOf('(!)') >= 0 || s.lastIndexOf('&') === s.length - 1 || s.lastIndexOf('|') === s.length - 1) {
        offset = 0;
      }
      for (let i = 0; i < s.length; i++) {
        let c = s.charAt(i);
        if ('|' == c && '|' == s.charAt(i + 1)) {
          orflag = 1;
        }
        if ('|' == c && andflag === 1) {
          offset = 0;
        }
        if ('|' == c && '|' != s.charAt(++i)) {
          offset = 0;
        }

        if ('&' == c && '&' == s.charAt(i + 1)) {
          andflag = 1;
        }
        if ('&' == c && orflag === 1) {
          offset = 0;
        }
        if ('&' == c && '&' != s.charAt(++i)) {
          offset = 0;
        }
      }
      if (offset === 0 || (orflag === 0 && andflag === 0)) {
        this.logicKeywordCont = false;
        this.form.get('logicKeyword').setValue(null);
      } else {
        this.logicKeywordCont = true;
        this.form.get('logicKeyword').setValue('-1');
      }
    }
    if (!this.logicKeywordCont) {
      return;
    }
    this.checkExist(s);
  }

  checkExist(s) {
    if (s.length > 0) {
      // 唯一性校验
      this.http.post(URLS.keywordList.url, { params: { keyword: s, targetId: this.form.get('targetId').value, msgType: this.messageService.getMsgTypeByName('tiktok', true), keywordType: this.form.get('keywordType').value, controlType: this.form.get('controlType').value, check: true }, ps: 1, pi: 1 }).subscribe(res => {
        if (res.total != 0) {
          if (res.list[0].id == this.record.id) {
            this.keywordRepe = true;
            this.form.get('keywordRepe').setValue('-1');
          } else {
            this.form.get('keywordRepe').setValue(null);
            this.keywordRepe = false;
          }
        } else {
          this.keywordRepe = true;
          this.form.get('keywordRepe').setValue('-1');
        }
      });
    } else {
      this.keywordRepe = true;
      this.form.get('keywordRepe').setValue('-1');
    }
  }

  save(value: any) {
    // 表示抖音类型
    value.msgType = this.messageService.getMsgTypeByName('tiktok', true);
    console.log(value);
    if (value.strategyType == 1) {
      value.target = 0;
    }
    let url = URLS.keywordAdd.url;
    if (value.id) {
      url = URLS.keywordEdit.url;
    }
    this.http.post(url, value).subscribe(res => {
      if (res.status === 0) {
        if (this.record.id > 0) {
          this.dialogService.notification.success(this.subject, '敏感字管控编辑成功');
        } else {
          this.dialogService.notification.success(this.subject, '敏感字管控新增成功');
        }
        this.modal.close(true);
      } else {
        if (this.record.id > 0) {
          this.dialogService.notification.error(this.subject, res.errorMsg);
        } else {
          this.dialogService.notification.error(this.subject, res.errorMsg);
        }
      }
    });
  }
  close() {
    this.modal.destroy();
  }

  search(value) {
    if (value) {
      let userEnumsTemp = [];
      this.userEnumsBack.forEach(element => {
        if (element.label.indexOf(value) > -1) {
          userEnumsTemp.push(element);
        }
      });
      this.userEnums = userEnumsTemp;
    } else {
      this.userEnums = this.userEnumsBack;
    }
  }

  searchBiz(value) {
    if (value) {
      let bizEnumsTemp = [];
      this.bizEnumsBack.forEach(element => {
        if (element.label.indexOf(value) > -1) {
          bizEnumsTemp.push(element);
        }
      });
      this.bizEnums = bizEnumsTemp;
    }
    // this.terminalChange(this.form.get('terminalId').value);
  }

  searchChannel(value) {
    if (value) {
      let channelEnumsTemp = [];
      this.channelEnums.forEach(element => {
        if (element.label.indexOf(value) > -1) {
          channelEnumsTemp.push(element);
        }
      });
      // this.searchOptions.channel.list = channelEnumsTemp;
    } else {
      // this.searchOptions.channel.list = this.channelEnums;
    }
  }
}
